import ConsumerBonusService from "@api/consumer/consumerBonusService";
import { EditBonusCodeForm } from "@components/consumer/bonuses";
import withPage from "@components/hoc/withPage";
import { useBreadcrumbs } from "@hooks/panelHooks";
import { ConsumerBonusCodeFull } from "@interfaces/consumer/bonusCodes";
import { FC, useEffect, useState } from "react";
import { useParams } from "react-router";
import { Card, Spinner } from "react-bootstrap";

const BonusCodePage: FC = () => {

    const { code_id } = useParams<{ code_id: string }>();
    const [bonus, setBonus] = useState<ConsumerBonusCodeFull>();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const load = async () => {
            setLoading(true);
            const api = new ConsumerBonusService();
            const result = await api.getBonusCode(code_id || '');

            if (result.success) {
                setBonus(result.data);
            }
            setLoading(false);
        }

        load();
    }, [code_id]);

    useBreadcrumbs('consumer.bonus.current.name', true, bonus?.code);

    if(!bonus) {
        return (
            <Card>
                <Card.Header>
                    <Card.Title>
                        Редактирование бонусного кода
                    </Card.Title>
                </Card.Header>
                <Card.Body className="text-center">
                    {
                        loading ? <Spinner className="mr-2" color="primary" /> : (
                            <Card.Text>
                                "Подарок не найден"
                            </Card.Text>
                        )
                    }
                </Card.Body>
            </Card>
        )
    }
    
    return (
        <EditBonusCodeForm code={bonus} />
    )
}

export default withPage(BonusCodePage);